import type { Observer, Subject } from '@/app/editor/iframe/atom/service/observer';
import type { AtomModel, TabSettingsData } from '@/app/editor/iframe/atom/Atom.model';
/**
 * Data changes: setting || render
 */
export class DataManager implements Subject {
  private static state = new Map();
  private static DataBucketCache = new Map();

  private observers: Observer[] = [];
  private static instance = new DataManager();

  /**
   * implements attach()
   * @param observer obs
   */
  attach(observer: Observer): void {
    // for (let index = 0; index < this.observers.length; index++) {
    //   const ob = this.observers[index];
    //   if( ob.constructor.name == observer.constructor.name
    //     && (ob as any).$el.attr("data-id") == (observer as any).$el.attr("data-id")
    //   ){
    //     this.observers[index] = observer;
    //     return;
    //   }
    // }
    const index = this.observers.indexOf(observer);
    if (index > -1) {
      return;
    }
    this.observers.push(observer);
    (window as any)._AtomObservers = this.observers;
  }
  /**
   * implements dettach()
   * @param observer obs
   */
  detach(observer: Observer): void {
    const index = this.observers.indexOf(observer);
    this.observers.splice(index, 1);
  }
  /**
   * implements notify()
   */
  notify(): void {
    for (const observer of this.observers) {
      observer.update(this);
    }
  }
  /**
   * get this instance
   * @returns this class instance
   */
  public static getInstance(): DataManager {
    return this.instance;
  }
  /**
   * get data from bucket
   * @param atomId id of atom
   * @returns data with the corresponding identifier
   */
  private static getData(atomId: string): TabSettingsData {
    return this.DataBucketCache.get(atomId);
  }
  /**
   * set data for bucket
   * @param atomId id of atom
   * @param data data want to update
   */
  private static setData(atomId: string, data: TabSettingsData) {
    this.DataBucketCache.set(atomId, data);
    (window as any)._AtomDataSetting = this.DataBucketCache;
  }
  /**
   * get data setting
   * getDataSetting tại đây hơi thừa, nhưng sau này có thểm cập nhật thêm những phần xử lý riêng khi get dataSetting
   * @param atomId id of atom
   * @returns data setting
   */
  public static getDataSetting(atomId: string): TabSettingsData {
    return this.getData(atomId);
  }
  /**
   * change data setting value
   * Nhiệm vụ update data theo atomId trong mảng _AtomDataSetting
   * @param data data setting
   * @param atomId id of atom
   */
  public static setDataSetting(data: TabSettingsData, atomId: string): void {
    this.setData(atomId, data);
  }
  /**
   * set state value
   * @param key object key
   * @param data object value
   * @param atomId id of Atom
   */
  public static setState(key: string, data: any, atomId: string) {
    // this.state[key] = data;
    const atomObjectById = this.state.get(atomId);
    if (atomObjectById) {
      atomObjectById[key] = data;
      this.state.set(atomId, atomObjectById);
    }
    if (!atomObjectById && atomId) {
      const newObj: any = {};
      newObj[key] = data;
      this.state.set(atomId, newObj);
    }
    (window as any)._AtomState = this.state;
  }
  /**
   * get state value
   * @param key key of object
   * @param atomId atom of id
   * @returns state value
   */
  public static getState(key: string, atomId: string): any {
    let result;
    const atomObjectById = this.state.get(atomId);
    if (atomObjectById) {
      result = atomObjectById[key];
    }
    return result;
  }
  /**
   * delete state when remove Atom
   * @param atomId id of Atom removed
   */
  public static removeState(atomId: string) {
    this.state.delete(atomId);
  }
  /**
   * get atom data
   * @param atomId id of atom
   * @returns atomModel
   */
  public static getAtomDataById(atomId: string): AtomModel {
    return this.getData(atomId).atom;
  }
  /**
   * get AtomDom
   * @param atomId id of atom
   * @returns atomModel
   */
  public static getAtomDomById(atomId: string): JQuery {
    return this.getData(atomId).$atom;
  }
  /**
   * register observer
   * @param observer class want to sucribe
   */
  public static registerObserver(observer: any) {
    this.instance.attach(observer);
  }
  /**
   * remove observer
   * @param observer class want to sucribe
   */
  public static removeObserver(observer: any) {
    this.instance.detach(observer);
  }

  /**
   * set data style
   * Set Field in AtomModel
   * @param value string
   * @param atomId id of atom
   * @param key style | settings | html | ....
   */
  public static setDataSettingField(value: any, atomId: string, key: string): void {
    const dataUpdate: TabSettingsData = this.getData(atomId);
    const atomData: AtomModel = dataUpdate?.atom;
    if (atomData) {
      Object.defineProperty(atomData, key, {
        value: value,
      });
      Object.defineProperty(dataUpdate, 'atom', {
        value: atomData,
      });
      this.setData(atomId, dataUpdate);
    }
  }
  /**
   * set data style
   * Set Field in AtomModel TabSettingsData
   * @param tabSetting { atom: ..., $atom: .., ...}
   * @param atomId id of atom
   * @param key style | settings | html | ....
   */
  public static setTabSettingsDataField(tabSetting: any, atomId: string): void {
    const dataUpdate: TabSettingsData = this.getData(atomId);
    if (dataUpdate) {
      for (const key in tabSetting) {
        if (Object.prototype.hasOwnProperty.call(tabSetting, key)) {
          const value = tabSetting[key];
          Object.defineProperty(dataUpdate, key, {
            value: value,
          });
        }
      }
      this.setData(atomId, dataUpdate);
    }
  }
}
